import { Avatar, Button, Stack, Typography } from "@mui/material";
import { ConfirmationDialog } from "./Dialog/ConfirmationDialog";
import Save from "@mui/icons-material/Save";

interface Props {
  disableActions?: boolean;
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  onCancel: () => void;
  userCanSave: boolean;
}

export const UnsavedWorkspaceChangesDialog: React.FC<Props> = ({
  open,
  disableActions = false,
  userCanSave,
  onSave,
  onCancel,
  onClose,
}) => {
  return (
    <ConfirmationDialog
      title="Unsaved Changes"
      open={open}
      actions={
        <Stack
          direction="row"
          spacing={1}
          width={"100%"}
          justifyContent="space-between"
          padding={2}
        >
          <Button
            color="secondary"
            variant="outlined"
            onClick={onClose}
            disabled={disableActions}
          >
            Cancel
          </Button>
          <Stack direction="row" spacing={1}>
            <Button
              color="secondary"
              variant="outlined"
              onClick={onCancel}
              disabled={disableActions}
            >
              Discard Changes
            </Button>
            <Button
              sx={{ backgroundColor: "#80cc8d", color: "white" }}
              onClick={onSave}
              disabled={disableActions}
            >
              {userCanSave ? "Save changes" : "Save as New Project"}
            </Button>
          </Stack>
        </Stack>
      }
      onClose={onClose}
    >
      <Stack minWidth={500} alignItems={"center"} gap={2} padding={2}>
        <Avatar sx={{ bgcolor: "#c8e6c9", color: "black" }}>
          <Save />
        </Avatar>
        <Typography fontWeight={600} fontSize="20px" mb={1}>
          Save Changes?
        </Typography>
        <Typography>
          Would you like to save your project before closing?
        </Typography>
      </Stack>
    </ConfirmationDialog>
  );
};
